import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import SvgIcon from "./components/ui/SvgIcon/index.js";
import ElementUI from "element-ui";
import VueMq from "vue-mq";
import axios from "axios";
import loadMore from "./utils/selectScroll";
import Base64 from "./utils/base64";
import md5 from "js-md5";
import VueClipboard from "vue-clipboard2";
import 'video.js/dist/video-js.css'

Vue.prototype.$axios = axios;
Vue.prototype.$Base64 = Base64;
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;

Vue.mixin({
    mounted() {
        const el = this.$el;
        if (el && el.tagName === "BUTTON" && el.classList.contains("el-button")) {
            let timeout;
            el.addEventListener("click", () => {
                if (!el.disabled) {
                    el.disabled = true;
                    timeout = setTimeout(() => {
                        el.disabled = false;
                    }, 500);
                }
            });

            // 清除定时器和禁用状态
            el.destroy = () => {
                clearTimeout(timeout);
                el.disabled = false;
            };
        }
    },
    destroyed() {
        const el = this.$el;
        if (el && el.destroy) {
            el.destroy();
        }
    },
});

Vue.use(SvgIcon);
Vue.use(ElementUI);
Vue.use(loadMore);
Vue.use(VueClipboard);
Vue.use(VueMq, {
    breakpoints: {
        // default breakpoints - customize this
        sm: 450,
        md: 1600,
        lg: Infinity,
    },
    defaultBreakpoint: "sm", // customize this for SSR
});

new Vue({
    store,
    Vue,
    router,
    render: (h) => h(App),
}).$mount("#app");

// export { App, Vue, store, router }
